import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('../views/List')
const Create = () => import('../views/Create')
const Display = () => import('../views/Display')
const Disabled = () => import('../views/Disabled')
const Published = () => import('../views/Published')
const Moderation = () => import('../views/Moderation')
const Updated = () => import('../views/Updated')

const ROUTE_NAME = 'profile:announcement:buyout:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const CREATE = p('create')
const UPDATE = p('update')
const DISPLAY = p('display')
const DISABLED = p('disabled')
const PUBLISHED = p('published')
const MODERATION = p('moderation')
const UPDATED = p('updated')

const withBuyout = r => ({ ...r.params, announcementType: 'buyout' })

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:VIEW'], options),
    }),
    route('create/', Create, CREATE, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:ADD'], options),
    }),
    route(':id/update/', Create, UPDATE, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:EDIT'], options),
    }),
    route(':id/', Display, DISPLAY, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:VIEW'], options),
    }),
    route(':id/:identifier/disabled/', Disabled, DISABLED, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:ADD'], options),
    }),
    route(':id/:identifier/published/', Published, PUBLISHED, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:ADD'], options),
    }),
    route(':id/:identifier/moderation/', Moderation, MODERATION, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:ADD'], options),
    }),
    route(':id/:identifier/updated/', Updated, UPDATED, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:ADD'], options),
    }),
    { path: '*', redirect: { name: LIST } },
  ]
}
